import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
  PaginateClientsActions,
  PaginateClientsState,
} from 'store/ducks/settings/clients';

import { SelectedFilterActions, SelectedFilterState } from 'store/ducks/filter';

import * as S from './styles';
import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridClients, FilterClients, ImportClientsModal } from 'components/settings/Clients';
import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';

export const ListClients: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();
  const [query, setQuery] = useState({
    limit: 10,
    page: 1,
  });
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state: any) => state.paginateClients
  ) as PaginateClientsState;

  const { data: dataFilter } = useSelector<RootStateOrAny>(
    (state: any) => state.selectedFilter
  ) as SelectedFilterState;

  const handleSubmitFilter = useCallback(
    (value: any) => {
      const data = {
        ...dataFilter,
        ...value,
        page: 1,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state: any) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const handlePageChange = useCallback(
    (value: any) => {
      const data = {
        ...dataFilter,
        page: value,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state: any) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const getData = useCallback(() => {
    dispatch(PaginateClientsActions.request({ ...query, ...dataFilter }));
  }, [dispatch, query, dataFilter]);

  const handleImportSuccess = useCallback(() => {
    setIsImportModalOpen(false);
    getData();
  }, [getData]);

  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')} <MenuSelector page="clients" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission('insertClient') && (
            <S.ButtonMini onClick={() => setIsImportModalOpen(true)}>
              {getTranslation('importXlsx')}
            </S.ButtonMini>
          )}
          {checkUserPermission('insertClient') && (
            <S.ButtonMini onClick={() => history.push('/settings/client/new')}>
              {getTranslation('novoCliente')}
            </S.ButtonMini>
          )}
          <FilterClients onFilter={handleSubmitFilter} />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridClients clients={data} />
        <Paginator
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </S.PageContent>
      
      <ImportClientsModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
        onSuccess={handleImportSuccess}
      />
    </MainContainer>
  );
};
